import axios from 'axios';

import { CHECKOUT_API_URL } from '../../helpers/urlConst';

axios.defaults.baseURL = CHECKOUT_API_URL;
axios.defaults.headers = { Accept: 'application/json' };
axios.defaults.withCredentials = false;

export const httpClient = axios;
